"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

const ImageLink = dynamic(() => import("./ImageLink").then((mod) => mod.ImageLink));

export const imageLinkInputs = [
  {
    name: "link",
    type: "url",
    required: true,
    friendlyName: "Link",
  },
  {
    name: "src",
    friendlyName: "Image",
    type: "file",
    required: true,
  },
  {
    name: "alt",
    type: "string",
    friendlyName: "Alt text",
    required: true,
  },
  {
    name: "height",
    type: "number",
  },
  {
    name: "width",
    type: "number",
  },
  {
    name: "objectFit",
    friendlyName: "Background Size",
    type: "text",
    defaultValue: "cover",
    enum: [
      {
        label: "contain",
        value: "contain",
        helperText: "The image should never get cropped",
      },
      {
        label: "cover",
        value: "cover",
        helperText: `The image should fill its box, cropping when needed`,
      },
    ],
  },
] as const satisfies Inputs;

export const ImageLinkComponent: RegisteredComponent = {
  name: "ImageLink",
  component: ImageLink,
  inputs: imageLinkInputs,
};
